import React, { useEffect, useState, useRef } from 'react';
import { AngelTile, AngelPost } from './AngelTile';
import { SmartBanner } from './SmartBanner';
import { getPersonalizedContent } from './UncoverAI';
import { X, ChevronLeft, ChevronRight, Heart, MessageCircle, Bookmark, Share2 } from 'lucide-react';
import { ResponsiveImage } from './ResponsiveImage';
// Mock data for demo purposes
const generateMockPosts = (): AngelPost[] => {
  const sizes = ['small', 'medium', 'large', 'wide', 'tall'] as const;
  const angelNames = ['Harper', 'Sophia', 'Zoey', 'Lana', 'Bella Blue', 'Bonny Blue', 'Kim Holland', 'Mia Khalifa'];
  const angelUsernames = ['IceQueen', 'GoldenShowerTina', 'ZoeyZooms', 'lana_luxe', 'BellaBlueX', 'BonnyBlueOfficial', 'KimHolland', 'MiaKhalifa'];
  const angelAvatars = ['https://uploadthingy.s3.us-west-1.amazonaws.com/8g53dZ7J3kRR9dJNnGuDbc/h2.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/bU73WvXeTZLjt1PKcu9KyE/image.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/5YZA8Ut1foPE5UkAGheBCE/image.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/cLp9w3hC4dVahxHuCeYw1i/488653244_669275086051024_406085801635574977_n.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/mSWACdMGnSXxSDMwRi1S6T/image.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/jq4Dkth7vgkmZJ8GZmzWDP/bonnyblue.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/bZ3iVXv5nZEMY6F847weq5/kimholland.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/gPbfjPdLfzNbqrZitYWXeS/MiaKhalifa.jpg'];
  const images = ['https://uploadthingy.s3.us-west-1.amazonaws.com/uyiXhnExYU79VjyGrEvQrS/masturbate.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/t1fMgo9T4WadxWeynPJ6vb/videoblur.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/uyiXhnExYU79VjyGrEvQrS/masturbate.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/bZ3iVXv5nZEMY6F847weq5/kimholland.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/gPbfjPdLfzNbqrZitYWXeS/MiaKhalifa.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/jq4Dkth7vgkmZJ8GZmzWDP/bonnyblue.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/8g53dZ7J3kRR9dJNnGuDbc/h2.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/bU73WvXeTZLjt1PKcu9KyE/image.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/5YZA8Ut1foPE5UkAGheBCE/image.png'];
  const badges = [['Top Angel'], ['New'], ['Trending'], ['VIP'], ['Featured'], ['Rising Star'], ['New Toy'], []];
  const captions = ["Just finished my yoga session... who wants to see what's under this towel? 😉", "I've got a special treat for my biggest fans... 😈", 'Should I wear red or black lingerie tonight? You decide! 💋', 'Missing the beach... who wants to join me next time? 🏖️', 'New toy just arrived! Want to see it in action? 💦', 'Feeling playful today... who wants to play? 💕', 'Just took a shower... still wet 💧', 'What would you do if you were here right now? 🔥', 'New outfit! What do you think? 👙'];
  const posts: AngelPost[] = [];
  for (let i = 0; i < 30; i++) {
    const randomAngelIndex = Math.floor(Math.random() * angelNames.length);
    const randomImageIndex = Math.floor(Math.random() * images.length);
    const randomBadgeIndex = Math.floor(Math.random() * badges.length);
    const randomCaptionIndex = Math.floor(Math.random() * captions.length);
    const randomSize = sizes[Math.floor(Math.random() * sizes.length)];
    const now = new Date();
    const randomHoursAgo = Math.floor(Math.random() * 48);
    const timestamp = new Date(now.getTime() - randomHoursAgo * 60 * 60 * 1000).toISOString();
    posts.push({
      id: `post-${i}`,
      angelId: `angel-${randomAngelIndex}`,
      angelName: angelNames[randomAngelIndex],
      angelUsername: angelUsernames[randomAngelIndex],
      angelAvatar: angelAvatars[randomAngelIndex],
      image: images[randomImageIndex],
      caption: captions[randomCaptionIndex],
      likes: Math.floor(Math.random() * 1000) + 50,
      comments: Math.floor(Math.random() * 100) + 5,
      timestamp,
      isLive: Math.random() > 0.9,
      isPremium: Math.random() > 0.7,
      isVideo: Math.random() > 0.5,
      badges: badges[randomBadgeIndex],
      size: randomSize
    });
  }
  return posts;
};
interface UncoverGridProps {
  onAngelSelect?: (angelId: string) => void;
  gridSize?: 'compact' | 'standard' | 'immersive';
}
export const UncoverGrid: React.FC<UncoverGridProps> = ({
  onAngelSelect,
  gridSize = 'standard'
}) => {
  const [posts, setPosts] = useState<AngelPost[]>([]);
  const [loading, setLoading] = useState(true);
  const [selectedPost, setSelectedPost] = useState<AngelPost | null>(null);
  const [likedPosts, setLikedPosts] = useState<string[]>([]);
  const [savedPosts, setSavedPosts] = useState<string[]>([]);
  const [banners, setBanners] = useState<any[]>([]);
  const [commentText, setCommentText] = useState('');
  const loadingRef = useRef<HTMLDivElement>(null);
  const gridRef = useRef<HTMLDivElement>(null);
  // Initial load
  useEffect(() => {
    const mockPosts = generateMockPosts();
    const {
      banners
    } = getPersonalizedContent();
    setPosts(mockPosts);
    setBanners(banners);
    setLoading(false);
  }, []);
  // Infinite scroll
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && !loading) {
        // Load more posts when scrolling to the bottom
        setLoading(true);
        setTimeout(() => {
          const newPosts = generateMockPosts();
          setPosts(prev => [...prev, ...newPosts]);
          setLoading(false);
        }, 1000);
      }
    }, {
      threshold: 0.1
    });
    if (loadingRef.current) {
      observer.observe(loadingRef.current);
    }
    return () => {
      if (loadingRef.current) {
        observer.unobserve(loadingRef.current);
      }
    };
  }, [loading]);
  // Handle opening a post
  const handleOpenPost = (post: AngelPost) => {
    setSelectedPost(post);
    document.body.style.overflow = 'hidden'; // Prevent scrolling when modal is open
  };
  // Handle closing the post modal
  const handleClosePost = () => {
    setSelectedPost(null);
    document.body.style.overflow = ''; // Restore scrolling
  };
  // Handle clicking on an angel profile
  const handleAngelClick = (angelId: string) => {
    if (onAngelSelect) {
      onAngelSelect(angelId);
    }
  };
  // Handle liking a post
  const handleLikePost = (postId: string) => {
    if (likedPosts.includes(postId)) {
      setLikedPosts(prev => prev.filter(id => id !== postId));
    } else {
      setLikedPosts(prev => [...prev, postId]);
    }
  };
  // Handle saving a post
  const handleSavePost = (postId: string) => {
    if (savedPosts.includes(postId)) {
      setSavedPosts(prev => prev.filter(id => id !== postId));
    } else {
      setSavedPosts(prev => [...prev, postId]);
    }
  };
  // Get grid classes based on grid size
  const getGridClasses = () => {
    switch (gridSize) {
      case 'compact':
        return 'grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-1 md:gap-2';
      case 'standard':
        return 'grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-2 md:gap-3';
      case 'immersive':
        return 'grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-4';
      default:
        return 'grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-2 md:gap-3';
    }
  };
  // Render grid with posts and banners
  const renderGrid = () => {
    const items = [];
    let bannerIndex = 0;
    for (let i = 0; i < posts.length; i++) {
      // Add a banner every 10 items
      if (i > 0 && i % 10 === 0 && bannerIndex < banners.length) {
        const banner = banners[bannerIndex % banners.length];
        const bannerSize = posts[i].size; // Use same size as the post it's replacing
        items.push(<SmartBanner key={`banner-${i}`} banner={banner} size={bannerSize} data-id="element-21663" />);
        bannerIndex++;
      }
      items.push(<AngelTile key={`post-${i}`} post={posts[i]} onOpenPost={handleOpenPost} gridSize={gridSize} data-id="element-21664" />);
    }
    return items;
  };
  return <div className="w-full" data-id="element-21665">
      {/* Masonry grid with responsive layout */}
      <div ref={gridRef} className={`grid ${getGridClasses()} transition-all duration-300`} data-id="element-21666">
        {renderGrid()}
      </div>

      {/* Loading indicator */}
      <div ref={loadingRef} className="py-8 flex justify-center" data-id="element-21667">
        {loading && <div className="flex flex-col items-center" data-id="element-21668">
            <div className="w-8 h-8 border-2 border-pink-500 border-t-transparent rounded-full animate-spin" data-id="element-21669"></div>
            <p className="mt-2 text-gray-400 text-sm" data-id="element-21670">
              Loading more content...
            </p>
          </div>}
      </div>

      {/* Post modal with improved UI */}
      {selectedPost && <div className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4 md:p-8 backdrop-blur-sm" data-id="element-21671">
          {/* Close button */}
          <button className="absolute top-4 right-4 z-10 w-10 h-10 flex items-center justify-center rounded-full bg-black/50 text-white hover:bg-black/70 transition-colors" onClick={handleClosePost} data-id="element-21672">
            <X size={24} data-id="element-21673" />
          </button>

          {/* Navigation buttons */}
          <button className="absolute left-4 top-1/2 -translate-y-1/2 z-10 w-10 h-10 flex items-center justify-center rounded-full bg-black/50 text-white hover:bg-black/70 transition-colors" data-id="element-21674">
            <ChevronLeft size={24} data-id="element-21675" />
          </button>
          <button className="absolute right-4 top-1/2 -translate-y-1/2 z-10 w-10 h-10 flex items-center justify-center rounded-full bg-black/50 text-white hover:bg-black/70 transition-colors" data-id="element-21676">
            <ChevronRight size={24} data-id="element-21677" />
          </button>

          {/* Post content */}
          <div className="w-full max-w-5xl bg-gray-900 rounded-lg overflow-hidden flex flex-col md:flex-row max-h-[90vh] shadow-2xl" data-id="element-21678">
            {/* Image/video side */}
            <div className="w-full md:w-7/12 relative bg-black flex items-center" data-id="element-21679">
              <ResponsiveImage src={selectedPost.image} alt={selectedPost.caption} className="w-full h-auto max-h-[70vh] md:max-h-[90vh]" priority={true} sizes="(max-width: 768px) 100vw, 60vw" loadingEffect="blur" data-id="element-21680" />
              {/* Premium overlay if needed */}
              {selectedPost.isPremium && <div className="absolute inset-0 bg-black/70 flex flex-col items-center justify-center text-white p-6 backdrop-blur-sm" data-id="element-21681">
                  <div className="w-16 h-16 rounded-full bg-gradient-to-r from-pink-500 to-purple-500 flex items-center justify-center mb-4" data-id="element-21682">
                    <Lock size={32} data-id="element-21683" />
                  </div>
                  <h3 className="text-2xl font-bold mb-2" data-id="element-21684">Premium Content</h3>
                  <p className="text-gray-300 text-center mb-6" data-id="element-21685">
                    Unlock this exclusive content to see what{' '}
                    {selectedPost.angelName} is hiding.
                  </p>
                  <button className="px-6 py-3 bg-gradient-to-r from-pink-600 to-purple-600 rounded-lg font-bold hover:from-pink-700 hover:to-purple-700 transition-colors shadow-lg shadow-pink-600/20" data-id="element-21686">
                    Unlock for 20 💎
                  </button>
                </div>}
            </div>

            {/* Comments/info side */}
            <div className="w-full md:w-5/12 flex flex-col h-full max-h-[50vh] md:max-h-[90vh]" data-id="element-21687">
              {/* Header with angel info */}
              <div className="p-4 border-b border-gray-800 flex items-center" data-id="element-21688">
                <div className="w-10 h-10 rounded-full overflow-hidden border border-gray-700 cursor-pointer hover:border-pink-500 transition-colors" onClick={() => handleAngelClick(selectedPost.angelId)} data-id="element-21689">
                  <img src={selectedPost.angelAvatar} alt={selectedPost.angelName} className="w-full h-full object-cover" data-id="element-21690" />
                </div>
                <div className="ml-3" data-id="element-21691">
                  <h3 className="font-medium text-white cursor-pointer hover:text-pink-400 transition-colors" onClick={() => handleAngelClick(selectedPost.angelId)} data-id="element-21692">
                    {selectedPost.angelName}
                  </h3>
                  <p className="text-xs text-gray-400" data-id="element-21693">
                    @{selectedPost.angelUsername}
                  </p>
                </div>
                <button className="ml-auto text-gray-400 hover:text-white transition-colors" data-id="element-21694">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-21695">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z" data-id="element-21696"></path>
                  </svg>
                </button>
              </div>

              {/* Comments section */}
              <div className="flex-1 overflow-y-auto p-4" data-id="element-21697">
                {/* Caption */}
                <div className="flex mb-4" data-id="element-21698">
                  <div className="w-8 h-8 rounded-full overflow-hidden mr-2" data-id="element-21699">
                    <img src={selectedPost.angelAvatar} alt={selectedPost.angelName} className="w-full h-full object-cover" data-id="element-21700" />
                  </div>
                  <div data-id="element-21701">
                    <p className="text-white" data-id="element-21702">
                      <span className="font-medium" data-id="element-21703">
                        {selectedPost.angelName}
                      </span>{' '}
                      {selectedPost.caption}
                    </p>
                    <p className="text-xs text-gray-400 mt-1" data-id="element-21704">2h ago</p>
                  </div>
                </div>

                {/* Sample comments */}
                <div className="space-y-4" data-id="element-21705">
                  <div className="flex" data-id="element-21706">
                    <div className="w-8 h-8 rounded-full overflow-hidden mr-2 bg-gray-700" data-id="element-21707"></div>
                    <div data-id="element-21708">
                      <p className="text-white" data-id="element-21709">
                        <span className="font-medium" data-id="element-21710">johnsmith</span> You look
                        amazing as always! 😍
                      </p>
                      <p className="text-xs text-gray-400 mt-1" data-id="element-21711">1h ago</p>
                    </div>
                  </div>
                  <div className="flex" data-id="element-21712">
                    <div className="w-8 h-8 rounded-full overflow-hidden mr-2 bg-gray-700" data-id="element-21713"></div>
                    <div data-id="element-21714">
                      <p className="text-white" data-id="element-21715">
                        <span className="font-medium" data-id="element-21716">mike_1985</span> Can't
                        wait to see more content like this!
                      </p>
                      <p className="text-xs text-gray-400 mt-1" data-id="element-21717">45m ago</p>
                    </div>
                  </div>
                  <div className="flex" data-id="element-21718">
                    <div className="w-8 h-8 rounded-full overflow-hidden mr-2 bg-gray-700" data-id="element-21719"></div>
                    <div data-id="element-21720">
                      <p className="text-white" data-id="element-21721">
                        <span className="font-medium" data-id="element-21722">true_fan</span> You're the
                        best angel on the platform! 💖
                      </p>
                      <p className="text-xs text-gray-400 mt-1" data-id="element-21723">20m ago</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Actions */}
              <div className="border-t border-gray-800 p-4" data-id="element-21724">
                <div className="flex justify-between mb-3" data-id="element-21725">
                  <div className="flex space-x-4" data-id="element-21726">
                    <button className="text-white transition-transform hover:scale-110 active:scale-95" onClick={() => handleLikePost(selectedPost.id)} data-id="element-21727">
                      <Heart size={24} className={likedPosts.includes(selectedPost.id) ? 'text-pink-500 fill-pink-500' : ''} data-id="element-21728" />
                    </button>
                    <button className="text-white transition-transform hover:scale-110 active:scale-95" data-id="element-21729">
                      <MessageCircle size={24} data-id="element-21730" />
                    </button>
                    <button className="text-white transition-transform hover:scale-110 active:scale-95" data-id="element-21731">
                      <Share2 size={24} data-id="element-21732" />
                    </button>
                  </div>
                  <button className="text-white transition-transform hover:scale-110 active:scale-95" onClick={() => handleSavePost(selectedPost.id)} data-id="element-21733">
                    <Bookmark size={24} className={savedPosts.includes(selectedPost.id) ? 'text-yellow-500 fill-yellow-500' : ''} data-id="element-21734" />
                  </button>
                </div>
                <p className="text-white text-sm mb-2" data-id="element-21735">
                  <strong data-id="element-21736">
                    {selectedPost.likes + (likedPosts.includes(selectedPost.id) ? 1 : 0)}{' '}
                    likes
                  </strong>
                </p>

                {/* Comment input */}
                <div className="flex items-center mt-3" data-id="element-21737">
                  <input type="text" placeholder="Add a comment..." className="flex-1 bg-gray-800 border border-gray-700 rounded-full px-4 py-2 text-white text-sm focus:outline-none focus:border-gray-600" value={commentText} onChange={e => setCommentText(e.target.value)} data-id="element-21738" />
                  <button className={`ml-2 text-pink-500 font-medium ${!commentText.trim() ? 'opacity-50 cursor-not-allowed' : 'hover:text-pink-400'}`} disabled={!commentText.trim()} data-id="element-21739">
                    Post
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>}
    </div>;
};